"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformOrderIdToManagementUrl = void 0;
function transformOrderIdToManagementUrl(orderId) {
    return `http://management.mydaytrip.com/#/order?orderId=${orderId}`;
}
exports.transformOrderIdToManagementUrl = transformOrderIdToManagementUrl;
//# sourceMappingURL=transformOrderIdToManagementUrl.js.map